export enum FeatureFlags {
  CLINICAL_COACHING = 'clinical_coaching',
  CONFERENCING = 'conferencing',
  CONFERENCE_RECORDING = 'conference_recording',
  CRISIS_OUTREACH = 'crisis_outreach',
  MEMBER_MODIFY_PRIMARY_NEED = 'member_modify_primary_need',
  TIME_TAP = 'time_tap'
}
